import {
  TaskTyp,
  type ICommonTask,
  type ITaskMeta,
  type ActionListActionFields_Task_Fragment,
  type ActionListActionFields_IHOrder_Fragment,
  type ActionListActionFields_PSC_Fragment,
} from "@/graphql";

export type EditTaskType = Omit<
  ActionListActionFields_Task_Fragment,
  | "__typename"
  | "preventsArchiving"
  | "createdAt"
  | "updatedAt"
  | "id"
  | "assigneeId"
  | "deadline"
  | "creatorId"
> & {
  assigneeId?: number;
  deadline?: string;
  creatorId?: number;
  id?: number;
  fileIds: number[];
  __typename?: ActionListActionFields_Task_Fragment["__typename"];
};

export type IHOrderEditType = Omit<
  ActionListActionFields_IHOrder_Fragment,
  | "__typename"
  | "createdAt"
  | "updatedAt"
  | "id"
  | "assigneeId"
  | "deadline"
  | "creatorId"
  | "technicalCategoryId"
  | "technicalPlaceId"
> & {
  assigneeId?: number;
  deadline?: string;
  creatorId?: number;
  id?: number;
  fileIds: number[];
  technicalCategoryId?: number;
  technicalPlaceId?: number;
  __typename?: ActionListActionFields_IHOrder_Fragment["__typename"];
};

export type ActionEditType = EditTaskType | IHOrderEditType | ActionListActionFields_PSC_Fragment;

export type DefaultTaskType = Partial<ICommonTask> & { document?: Document | null };

export function defaultTask(): EditTaskType {
  return {
    description: "",
    deadline: undefined,
    status: 1,
    assigneeId: undefined,
    creatorId: undefined,
    type: TaskTyp.common,
    fileIds: [],
  };
}

export function getMetaFromTask(
  meta: ActionListActionFields_Task_Fragment["meta"],
): ITaskMeta | undefined {
  if (meta == null) {
    return undefined;
  }
  if ("veto" in meta) {
    return {
      veto: meta.veto,
    };
  }
  if ("recommend" in meta) {
    return {
      recommend: meta.recommend,
    };
  }
  if ("customAttributes" in meta) {
    return {
      customAttributes: meta.customAttributes,
    };
  }
  throw Error("unknown Task meta");
}
